// extracted by mini-css-extract-plugin
export default {"inputAndGo":"pvX9-","videoMenuItem":"HJ1ga"};